var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import { SvgCircleIcon } from '../elements/svg-circle-icon';
export var EmptyIcon = function (props) {
  return React.createElement(SvgCircleIcon, __assign({}, props, {
    glyphWidth: 64,
    glyphHeight: 65
  }), React.createElement("path", {
    "fill-rule": "evenodd",
    "clip-rule": "evenodd",
    d: "M10.2802 7.75531L7.12769 10.9078L13.0328 16.813C13.0328 16.813 13.0328 16.813 13.0328 16.8131L16.3207 20.101C16.3208 20.101 16.3208 20.101 16.3208 20.101L43.4379 47.2179C43.4378 47.218 43.4378 47.218 43.4378 47.218L46.5141 50.2943C46.5141 50.2943 46.5141 50.2943 46.5142 50.2943L51.2633 55.0434L54.4159 51.8909L49.6667 47.1417C57.4187 37.8003 56.9176 23.9182 48.1633 15.1639C39.409 6.4096 25.5268 5.90846 16.1854 13.6605L10.2802 7.75531ZM19.4491 16.9241L46.6147 44.0897C52.7343 36.503 52.2702 25.3645 45.2223 18.3166C38.1743 11.2687 27.0358 10.8045 19.4491 16.9241ZM14.5361 48.791C6.89211 41.147 5.54055 29.5934 10.4814 20.5668L13.9458 24.0312C10.7394 31.1422 12.0576 39.796 17.9002 45.6386C23.7428 51.4812 32.3966 52.7993 39.5076 49.593L42.7603 52.8457C33.7338 57.7865 22.1801 56.435 14.5361 48.791Z",
    fill: "black"
  }));
};
export var EmptyIconGlyph = function (props) {
  return React.createElement(EmptyIcon, __assign({}, props, {
    variant: 'glyph'
  }));
};